import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import DownSquareOutlinedSvg from "@ant-design/icons-svg/es/asn/DownSquareOutlined";
import AntdIcon from "../components/AntdIcon";
var DownSquareOutlined = function DownSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DownSquareOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  DownSquareOutlined.displayName = 'DownSquareOutlined';
}
export default /*#__PURE__*/React.forwardRef(DownSquareOutlined);